/* eslint-disable react-hooks/exhaustive-deps */

import { useAuth } from "context/AuthContext";
import { Outlet } from "react-router";
import { UserInfo } from "components/user-info";

import "./styles.scss";

import { NavLink, useSearchParams } from "react-router-dom";
import { NavMenu } from "components/navmenu";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { registerLocale } from "react-datepicker";
import DatePicker from "react-datepicker";
import { getListaResgates } from "services/store.service";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import "moment/locale/pt-br";
import { RegulamentoFooter } from "components/regulamento-footer";
import { BiUser } from "react-icons/bi";
import { UserAvatar } from "components/user-avatar";

moment.locale("pt-br");

export function Resgates() {
  const { user } = useAuth();
  const [items, setItems] = useState<any>();
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();
  const { register, handleSubmit, setValue, reset, control } = useForm();
  const [loading, setLoading] = useState<boolean>(false);

  async function loadData() {
    setLoading(true);
    const data = await getListaResgates(
      startDate ? startDate : "2023-01-01T00:00:00.000Z",
      endDate ? endDate : "NOW"
    );
    setItems(data);
    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    if (user) {
      // console.log(user.challenges);
      loadData();
    }
  }, [user]);

  useEffect(() => {
    if (endDate) {
      endDate.setHours(20, 59, 59); //ajustar depois
      setEndDate(endDate);
    }
    if (user) {
      loadData();
    }
  }, [user, startDate, endDate]);

  registerLocale("pt-BR", pt);

  if (!user) return null;

  return (
    <>
      <Helmet>
        <title>CONTA COMIGO BRB</title>
      </Helmet>
      <div id="home-wrapper" className="min-h-screen">
        <div className="z-10 relative flex flex-col items-center space-y-0">
          <NavMenu />

          <div className="w-full flex justify-center md:p-0">
            <UserInfo />
          </div>
          <div
            className="w-full md:w-[1200px] p-4 md:p-8 md:flex"
            id="filterResgates"
          >
            <div className="md:w-[40%]">
              <h2>
                <strong>Itens Resgatados</strong>
              </h2>
              <p className="text-white">
                Lista com <strong>todos</strong> os itens que foram adiquiridos
                no <strong>mercado de estrelas</strong>, <strong>cards</strong>{" "}
                e <strong>prêmios</strong>.
              </p>
            </div>
            <div className="md:w-[60%] flex justify-end filterDate">
              <form
                id="search-form-theme-calendar"
                autoComplete="off"
                noValidate
              >
                <div>
                  <Controller
                    name="startTime"
                    control={control}
                    render={() => (
                      <DatePicker
                        placeholderText="Data Inicio"
                        className="input md:mr-2 w-full md:w-auto"
                        locale="pt-BR"
                        dateFormat="dd/MM/yyyy"
                        selected={startDate}
                        onChange={(e: any) => {
                          setStartDate(e);
                          setValue("startTime", new Date(e as Date).getTime());
                        }}
                      />
                    )}
                  />
                </div>
                <div>
                  <Controller
                    name="endTime"
                    control={control}
                    render={() => (
                      <DatePicker
                        placeholderText="Data Fim"
                        className="input md:mr-2 w-full md:w-auto"
                        locale="pt-BR"
                        dateFormat="dd/MM/yyyy"
                        selected={endDate}
                        onChange={(e: any) => {
                          setEndDate(e);
                          setValue("endTime", new Date(e as Date).getTime());
                        }}
                      />
                    )}
                  />
                </div>
                <div className="flex justify-center items-center">
                  <button
                    type="button"
                    onClick={() => {
                      reset();
                      setStartDate("");
                      setEndDate("");
                    }}
                  >
                    Limpar
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="w-full md:w-[1200px]" id="resgates">
            {loading ? (
              <p className="text-center loading">Carregando...</p>
            ) : (
              <Scrollbars
                style={{ width: "100%", height: 400 }}
                className="contentExtrato"
                renderTrackVertical={(props) => (
                  <div {...props} className="track-vertical" />
                )}
              >
                <table className="table">
                  <thead>
                    <tr>
                      <th className="w-[120px] rounded-l-md md:rounded-none">
                        IMAGEM
                      </th>
                      {/* <th>ITEM</th> */}
                      <th>ITEM</th>
                      <th>IMAGEM</th>
                      <th>NOME</th>
                      <th>DATA</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items
                      ?.filter((item: any) => {
                        if (item.type !== 1) {
                          return item;
                        }
                      })
                      .map((item: any) => (
                        <tr key={item.item}>
                          <td>
                            <img
                              src={item.item_image}
                              alt="img"
                              className="imgList"
                            />
                          </td>
                          {/* <td>{item._id}</td> */}
                          <td>{item.item_name}</td>
                          <td>
                            {!!item.extra.avatar ? (
                              <div className="avatarContent">
                                <UserAvatar
                                  data={{ ...item, ...item?.extra }}
                                  responsive={true}
                                />
                              </div>
                            ) : (
                              <img
                                src={item.image.small.url}
                                alt="imgPlayer"
                                className="imgList"
                              />
                            )}
                          </td>
                          <td>{item.player_name}</td>
                          <td>
                            <span className="hidden md:block">
                              {moment(item.time).format("DD/MM/YYYY HH:mm")}
                            </span>
                            <span className="md:hidden block w-16">
                              {moment(item.time).format("DD/MM YYYY HH:mm")}
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </Scrollbars>
            )}
          </div>
        </div>
        <RegulamentoFooter />
      </div>
      <Outlet />
    </>
  );
}
